import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useLocation, Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Paper,
  CircularProgress,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import {
  selectCurrentCompany,
  getCompanyByReference,
} from '../store/companySlice';

import {
  selectCard,
  selectIdentity,
  getSessionByReference,
  getPaymentCardSessionByIdentityReference,
} from '../store/widgetSlice';

import { inIframe, isMobile } from '../helpers';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: [theme.spacing(2)],
    },
    maxWidth: 900,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  content: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  innerContent: {
    textAlign: 'center',
  },
  alertContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: ' center',
    marginBottom: 25,
  },
  alertContainerInner: {
    display: 'inline-block',
  },
  alignCenter: {
    textAlign: 'center',
  },
  loader: {
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
    justifyContent: 'center',
    top: 0,
    left: 0,
    zIndex: 10000,
    width: '100%',
    height: '100%',
  },
}));

const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

export default function Verification() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const company = useSelector(selectCurrentCompany);
  const identity = useSelector(selectIdentity);
  const card = useSelector(selectCard);
  const query = useQuery();
  let { reference } = useParams();

  if (!reference) {
    reference = query.get('reference');
  }

  useEffect(() => {
    if (reference) {
      dispatch(getCompanyByReference({ reference }));
      dispatch(getSessionByReference({ reference }));
      dispatch(getPaymentCardSessionByIdentityReference({ reference }));
    }
  }, [dispatch, reference]);

  return company
    ? (
      <>
        {
        identity && identity.status !== 'P' && card && card.status === 'P'
        && (<Redirect to={`/verify/next?reference=${reference}`} />)
      }
        { (isMobile() || (company && company.customAttributes && company.customAttributes.enableDesktopUploads))
          ? (
            <>
              {
            inIframe()
              ? (
                <Grid container className={classes.content}>
                  <Grid item xs={12} className={classes.innerContent}>
                    <iframe
                      title="Guest Ranger Identity Verification"
                      src={`https://docupass.app/${reference}`}
                      frameBorder="0"
                      allow="camera;microphone"
                      allowtransparency="true"
                      style={{ width: '870px', height: '65vh', maxWidth: '100%' }}
                    />
                  </Grid>
                </Grid>
              )
              : (
                <Paper className={classes.root} elevation={1}>
                  <Grid container className={classes.content}>
                    <Grid item xs={12} className={classes.innerContent}>
                      <iframe
                        title="Guest Ranger Identity Verification"
                        src={`https://docupass.app/${reference}`}
                        frameBorder="0"
                        allow="camera;microphone"
                        allowtransparency="true"
                        style={{ width: '870px', height: '65vh', maxWidth: '100%' }}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              )
            }
            </>
          )
          : (
            <>
              <Grid container className={classes.content}>
                <Grid item xs={12}>
                  <div>
                    <h1 className={classes.alignCenter}>Open this window on a mobile device</h1>
                    <div className={classes.alertContainer}>
                      <div className={classes.alertContainerInner}>
                        <Alert severity="warning">
                          A mobile device is required to complete the verification process.
                        </Alert>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </>
          )}
      </>
    )
    : (
      <>
        <Grid container className={classes.content}>
          <Grid item xs={12}>
            <div>
              <div className={classes.alertContainer}>
                <div className={classes.alertContainerInner}>
                  <div className={classes.loader}>
                    <CircularProgress size={100} />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </>
    );
}
